import PropTypes from 'prop-types';
import React from 'react';
import Button from '@strava/ui/Button';
import createNetworkingClient from 'utils/networking-client';
import styles from './index.scss';
import { useFeedEntityContext } from '../../../state/FeedEntityContext';
import { indexProps, cursorDataProps } from '../../../props/feed-prop-types';
import Card from '../media/Card';
import EntryBody from '../media/EntryBody';
import Media from '../media/Media';
import MediaLeft from '../media/MediaLeft';
import MediaBody from '../media/MediaBody';

function BackgroundHeaderImage({ backgroundImage }) {
  return backgroundImage ? (
    <div className={styles.entryMediaContainer}>
      <div className={styles.entryImage}>
        <img
          className={styles.backgroundHeaderImage}
          src={backgroundImage}
          alt=""
          data-testid="promo-img"
        />
      </div>
    </div>
  ) : null;
}

BackgroundHeaderImage.propTypes = {
  backgroundImage: PropTypes.string.isRequired
};

const PromoEntry = ({
  entity,
  description,
  badge,
  backgroundImage,
  impression,
  click,
  headline,
  intersectionObserverRef,
  cursorData,
  index,
  ctaText,
  ctaUrl
}) => {
  const { entityState } = useFeedEntityContext();

  return (
    <Card
      key={index}
      index={index}
      cursorData={cursorData}
      ref={intersectionObserverRef}
    >
      {/* Background Header Image for Fancy Promo */}
      <BackgroundHeaderImage backgroundImage={backgroundImage} />

      <EntryBody impression={impression}>
        <Media>
          {/* Left Logo Badge */}
          <MediaLeft bigBadge={true}>{badge}</MediaLeft>

          {/* Right Main Body */}
          <MediaBody>
            <a
              href={ctaUrl}
              onClick={() => {
                createNetworkingClient({ baseUrl: null, headers: null }).get(
                  click
                );
                entityState.trackAnalytics({
                  action: 'click',
                  element: `${entity.toLowerCase()}_headline_and_description`
                });
              }}
            >
              <h3 className={styles.titleText}>{headline}</h3>
              <div className={styles.details}>{description}</div>
            </a>

            <Button
              variant="primary"
              type="button"
              className={styles.ctaBtn}
              onClick={() => {
                createNetworkingClient({ baseUrl: null, headers: null }).get(
                  click
                );
                entityState.trackAnalytics({
                  action: 'click',
                  element: `${entity.toLowerCase()}_cta_button`
                });
                window.location.href = ctaUrl;
              }}
            >
              {ctaText}
            </Button>
          </MediaBody>
        </Media>
      </EntryBody>
    </Card>
  );
};

PromoEntry.propTypes = {
  entity: PropTypes.oneOf(['FancyPromo', 'SimplePromo']).isRequired,
  description: PropTypes.string.isRequired,
  impression: PropTypes.string.isRequired,
  click: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string,
  badge: PropTypes.node.isRequired,
  headline: PropTypes.string.isRequired,
  intersectionObserverRef: PropTypes.func.isRequired,
  cursorData: cursorDataProps.isRequired,
  index: indexProps.isRequired
};

PromoEntry.defaultProps = {
  backgroundImage: ''
};

export default PromoEntry;
